/* =========================================================================
 * FAQ Hub search + category filter  (sections/x-21e-faq-hub.liquid)
 * -------------------------------------------------------------------------
 * Client-side filtering over the server-rendered Q&A blocks.
 *   - Text search matches question + answer + keywords (from #FaqSearchIndex).
 *   - Best-match scoring: entries are ranked by how many query words they
 *     contain, and only the highest-scoring tier is shown (so filler words in a
 *     natural question no longer force zero results).
 *   - Category dropdown narrows to one category.
 *   - Both combine; empty value = no constraint.
 * No-JS fallback: every answer is already visible server-side.
 *
 * Search tracking (anonymous): committed searches are logged to the toolbox
 * API for analytics (top searches + zero-result content gaps). Gated behind
 * the Shopify Customer Privacy API (analytics consent); fails closed.
 * ========================================================================= */
(function () {
  'use strict';

  var TRACK_URL = 'https://toolbox-api.21energy.io/api/faq-search/event';
  var MIN_QUERY_LEN = 3;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  // Only track if the visitor has granted analytics consent. Fails closed.
  function analyticsAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed() === true;
      }
    } catch (e) { /* no-op */ }
    return false;
  }

  function sendEvent(payload) {
    var data = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        // text/plain is CORS-safelisted (no preflight); the API json-parses regardless.
        navigator.sendBeacon(TRACK_URL, new Blob([data], { type: 'text/plain;charset=UTF-8' }));
        return;
      }
    } catch (e) { /* fall through to fetch */ }
    try {
      fetch(TRACK_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: data, keepalive: true }).catch(function () {});
    } catch (e) { /* no-op */ }
  }

  function buildIndex(sid) {
    var el = document.getElementById('FaqSearchIndex-' + sid);
    var map = {};
    if (!el) return map;
    try {
      JSON.parse(el.textContent).forEach(function (item) {
        map[item.id] = ((item.q || '') + ' ' + (item.a || '') + ' ' + (item.kw || '')).toLowerCase();
      });
    } catch (e) { /* fall back to DOM text below */ }
    return map;
  }

  function initHub(hub) {
    if (hub._faqInit) return;
    hub._faqInit = true;

    var sid = hub.id.replace('faqhub-', '');
    var input = hub.querySelector('[data-faq-search-input]');
    var filter = hub.querySelector('[data-faq-filter]');
    var blocks = Array.prototype.slice.call(hub.querySelectorAll('[data-faq-id]'));
    var noResults = hub.querySelector('[data-faq-noresults]');
    var index = buildIndex(sid);

    var shop = hub.getAttribute('data-faq-shop') || window._21eShopDomain || window.location.hostname;
    var locale = hub.getAttribute('data-faq-locale') || document.documentElement.lang || '';
    var lastVisible = blocks.length;   // result count of the current query
    var lastLogged = '';               // dedupe: last query already sent this session

    function haystack(block) {
      var id = block.getAttribute('data-faq-id');
      if (index[id]) return index[id];
      // Fallback: read straight from the DOM if the JSON island is missing.
      return (block.textContent || '').toLowerCase();
    }

    // Split a block's haystack into words once, cached by id.
    var wordCache = {};
    function wordsFor(block) {
      var id = block.getAttribute('data-faq-id');
      if (wordCache[id]) return wordCache[id];
      var words;
      try {
        words = haystack(block).split(/[^\p{L}\p{N}]+/u);
      } catch (e) {
        words = haystack(block).split(/[^a-z0-9]+/i); // fallback if \p{L} unsupported
      }
      wordCache[id] = words.filter(Boolean);
      return wordCache[id];
    }

    // Count how many query terms PREFIX some word in the block. Prefix (not bare
    // substring) so "Vorlauftem" still matches "Vorlauftemperatur" but the German
    // filler "ich" no longer matches the English "which", "miner" no longer
    // matches "antminer", etc. — avoiding cross-word false hits.
    function scoreBlock(words, terms) {
      var s = 0;
      for (var i = 0; i < terms.length; i++) {
        var t = terms[i];
        for (var j = 0; j < words.length; j++) {
          if (words[j].indexOf(t) === 0) { s++; break; }
        }
      }
      return s;
    }

    function apply() {
      var q = (input && input.value || '').trim().toLowerCase();
      var terms = q ? q.split(/\s+/).filter(function (t) { return t.length >= 2; }) : [];
      var cat = (filter && filter.value) || '';
      var visible = 0;

      if (!terms.length) {
        // No text query: show everything in the (optional) category.
        blocks.forEach(function (block) {
          var show = !cat || block.getAttribute('data-faq-category') === cat;
          block.hidden = !show;
          if (show) visible++;
        });
      } else {
        // Best-match scoring instead of "every word must match". A natural
        // question ("Was ist die maximale Vorlauftemperatur fuer Antminer S19?")
        // used to return nothing because filler words matched no answer. Filler
        // words score 0 across all blocks, so they don't distort the ranking; we
        // then reveal only the highest-scoring tier.
        var scored = [];
        var maxScore = 0;
        blocks.forEach(function (block) {
          var catOk = !cat || block.getAttribute('data-faq-category') === cat;
          if (!catOk) { block.hidden = true; return; }
          var sc = scoreBlock(wordsFor(block), terms);
          scored.push({ block: block, score: sc });
          if (sc > maxScore) maxScore = sc;
        });
        // For long queries require >=2 matching words so a single common word in a
        // full sentence doesn't surface everything; short queries need just 1.
        var minNeeded = terms.length >= 4 ? 2 : 1;
        var threshold = maxScore >= minNeeded ? maxScore : Infinity;
        scored.forEach(function (o) {
          var show = o.score >= threshold; // top tier only; Infinity => show none
          o.block.hidden = !show;
          if (show) visible++;
        });
      }

      lastVisible = visible;
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
      hub.classList.toggle('is-searching', q !== '' || cat !== '');
    }

    // Log a committed search (after the visitor settles on a query).
    function logSearch() {
      var raw = (input && input.value || '').trim();
      if (raw.length < MIN_QUERY_LEN) return;
      if (raw === lastLogged) return;          // skip repeats of the same query
      if (!analyticsAllowed()) return;         // consent gate (fails closed)
      lastLogged = raw;
      sendEvent({
        shop: shop,
        locale: locale,
        query: raw.slice(0, 200),
        resultCount: lastVisible,
        category: (filter && filter.value) || null
      });
    }

    if (input) {
      input.addEventListener('input', debounce(apply, 150));
      input.addEventListener('input', debounce(logSearch, 1200));   // log when typing settles
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { apply(); logSearch(); } });
      input.addEventListener('blur', logSearch);
    }
    if (filter) filter.addEventListener('change', function () { apply(); logSearch(); });
    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll('._21e-faqhub').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
